import React from "react";
import { icons } from "../assets/icons";

export const Icon = ({ name, style }) => {
	const SelectedIcon = icons[name] || icons["default"];

	return <SelectedIcon style={style} />;
};
